import { render, staticRenderFns } from "./ShowVideoCategoryPage.vue?vue&type=template&id=497489c2&"
import script from "./ShowVideoCategoryPage.vue?vue&type=script&lang=js&"
export * from "./ShowVideoCategoryPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports